/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable no-console */
import { takeLatest, takeEvery, put, select, call } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { delay } from 'redux-saga';
import { uniq } from 'lodash';
import { searchElementMatch, locales, setNotification } from 'utils';
import {
    ADD_NEW_PROMOTION,
    LOAD_PROMOTIONS,
    LOAD_EDITABLE_PROMOTION,
    LOAD_SELL_PRICES_FOR_PROMOTION,
    EDIT_PROMOTION,
    ATTACH_SELLPRICES_TO_PROMOTION,
    LOAD_PROMOTION_SELLPRICES,
    UPDATE_SELL_PRICES,
    DELETE_SELL_PRICES,
    SET_DISABLE_PROMOTION,
} from '../types/promotionTypes';
import { getProductGroupsApi } from '../api/productGroupApi';
import { getConfigurationsApi } from '../api/configurationApi';
import {
    addNewPromotionApi,
    updateTranslatePromotionApi,
    getPromotionsApi,
    attachResellersProductGroupToPromotionApi,
    editPromotionApi,
    getSellPrices,
    updateSellPricesApi,
    deleteSellPricesApi,
    enableDisablePromotionApi,
} from '../api/promotionApi';
import * as PromotionActions from '../actions/promotionActions';

const getLayout = state => state.layout;
const getPromotion = state => state.promotion;
const getForm = state => state.form;

// A D D   N E W   P R O M O T I O N
function* attachResellersProductGroupToPromotion(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = action.resellersProductGroup;

        const result = yield attachResellersProductGroupToPromotionApi(params);

        if (result.status !== 202) {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }

        yield put(PromotionActions.attachResellersProductGroupToPromotionRes(true, true));
        yield delay(50);
        yield put(PromotionActions.attachResellersProductGroupToPromotionRes(false, false));
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'promotion.notification.attachResellersProductGroupsError');
        yield put(PromotionActions.attachResellersProductGroupToPromotionErr(false, false));
    }
}

function* updatePromotionTranslate(action) {
    const type = 'add';
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const data = {
            reseller_id: action.data.reseller_id,
            promotion_id: action.data.promotion_id,
            description: '',
        };

        const params = { bulk: [] };
        locales.forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === EDIT_PROMOTION)) {
                params.bulk.push({
                    ...data,
                    ...action.data[lc],
                });
            }
        });

        const result = yield updateTranslatePromotionApi(params);

        if (result.status !== 202) {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }

        yield put(PromotionActions.updateTranslatePromotionRes(type, true, true));
        yield delay(50);
        yield put(PromotionActions.updateTranslatePromotionRes(type, false, false));
    } catch (e) {
        setNotification('error', locale, 'global.error', 'promotion.notification.translateErrorFunction');
        yield put(PromotionActions.updateTranslatePromotionErr(type, false, false));
        console.log(e);
    }
}


// L O A D   E D I T A B L E   P R O M O T I O N S
function* loadEditablePromotionSaga(action) {
    try {
        const params = { filter: JSON.stringify({ id: action.id }) };
        const result = yield getPromotionsApi(params);

        if (result.status === 200) {
            const hit = result.data.hits[0];
            yield delay(200);
            yield put(PromotionActions.loadEditablePromotionRes(hit));
        } else {
            yield put(PromotionActions.loadEditablePromotionErr());
        }
    } catch (e) {
        yield put(PromotionActions.loadEditablePromotionErr());
        console.log(e);
    }
}

export function* loadEditablePromotionWatcher() {
    yield takeLatest(LOAD_EDITABLE_PROMOTION, loadEditablePromotionSaga);
}
// L O A D   E D I T A B L E   P R O M O T I O N S

// A D D   N E W   P R O M O T I O N
function* addNewPromotionSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield addNewPromotionApi(action.data);

        if (result.status === 202) {
            yield call(updatePromotionTranslate, action);
            yield call(attachResellersProductGroupToPromotion, action);
            yield put(PromotionActions.addNewPromotionRes());

            if (action.isCustomized) {
                yield call(loadEditablePromotionSaga, {
                    ...action,
                    data: {
                        ...action.data,
                        id: action.data.promotion_id,
                    },
                });
                yield put(PromotionActions.savePromoToCustomizeRes({
                    ...action.data,
                    resellers: action.resellersProductGroup.resellers,
                }));
                yield delay(50);
                yield put(push(`/marketing/promotions/customize/${action.data.promotion_id}`));
            } else {
                yield put(push('/marketing/promotions/'));
            }

            setNotification('success', locale, 'global.success', 'promotion.notification.addDiscountSuccess');
        } else {
            yield put(PromotionActions.addNewPromotionErr());
            setNotification('error', locale, 'global.error', 'promotion.notification.addDiscountError');
        }
    } catch (e) {
        yield put(PromotionActions.addNewPromotionErr());
        setNotification('error', locale, 'global.error', 'promotion.notification.addDiscountError');
        console.log(e);
    }
}

export function* addNewPromotionWatcher() {
    yield takeLatest(ADD_NEW_PROMOTION, addNewPromotionSaga);
}
// A D D   N E W   P R O M O T I O N

// L O A D   P R O M O T I O N S
function* loadPromotionsSaga() {
    const { offset, limit, sort, filters } = yield select(getPromotion);
    const { locale } = yield select(getLayout);

    try {
        const params = { limit, offset };

        const sendFilters = {};

        if (filters['title.translate'] !== '') {
            sendFilters['title.translate'] = searchElementMatch(filters['title.translate'], locale);
        }

        if (filters.resellers?.length > 0) {
            sendFilters.resellers = filters.resellers;
        }

        if (filters.crossed !== '') {
            sendFilters.crossed = filters.crossed;
        }

        if (filters.start_date.length > 0) {
            sendFilters.start_date = { between: filters.start_date };
        }

        if (filters.end_date.length > 0) {
            sendFilters.end_date = { between: filters.end_date };
        }

        params.filter = JSON.stringify(sendFilters);

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'title') {
                params.sort_by = JSON.stringify({ 'title.original_title': sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        const result = yield getPromotionsApi(params);

        if (result.status === 200) {
            yield put(PromotionActions.loadPromotionsRes(result.data));
        }
    } catch (e) {
        yield put(PromotionActions.loadPromotionsErr());
        console.log(e);
    }
}

export function* loadPromotionsWatcher() {
    yield takeLatest(LOAD_PROMOTIONS, loadPromotionsSaga);
}
// L O A D   P R O M O T I O N S


// L O A D   S E L L   P R I C E S   F O R   P R O M O T I O N
function* loadSellPricesForPromotionSaga() {
    try {
        const promotion = yield select(getPromotion);
        const layout = yield select(getLayout);
        const form = yield select(getForm);

        const { sellPrices } = promotion;
        const { locale } = layout;
        const { sellPricesForm } = form;
        const { offset, limit, sort, filters } = sellPrices;

        const params = {
            offset,
            limit,
            filter: {
                all: true,
            },
            joins: JSON.stringify(['carriers']),
        };

        if (filters['name.translate'] !== '') {
            params.filter['name.translate'] = searchElementMatch(filters['name.translate'], locale);
        }

        if (sellPricesForm !== undefined && sellPricesForm.values.productGroup && sellPricesForm.values.productGroup.length > 0) {
            params.filter.product_groups = sellPricesForm.values.productGroup;
        }

        if (filters['configuration_property.carrier_id'].length > 0) {
            params.filter['configuration_property.carrier_id'] = filters['configuration_property.carrier_id'];
        }

        if (filters['configuration_property.property_value_id'].length > 0) {
            params.filter.and = filters['configuration_property.property_value_id'].map(cp => ({
                'configuration_property.property_value_id': cp,
            }));
        }

        if (filters['configuration_property.property_value_id'].length > 0) {
            params.filter.and = filters['configuration_property.property_value_id'].map(cp => ({
                'configuration_property.property_value_id': cp,
            }));
        }

        if (filters.configuration_type.length > 0) {
            params.filter.configuration_type = filters.configuration_type;
        }

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'name') {
                params.sort_by = JSON.stringify({ 'name.original_name': sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        params.filter = JSON.stringify(params.filter);
        const result = yield getConfigurationsApi(params);

        if (result.status === 200) {
            const { hits } = result.data;
            let product_groups = [];

            hits.forEach((hit) => {
                product_groups = [
                    ...product_groups,
                    ...hit.sell_price.map(s => s.product_group_id),
                ];
            });

            product_groups = uniq(product_groups);

            const getProductGroups = yield getProductGroupsApi({ filter: JSON.stringify({ id: product_groups }) });
            product_groups = getProductGroups.data.hits.map(hit => ({
                id: hit.id,
                name: hit.name,
                unique_name: hit.unique_name,
            }));
            yield put(PromotionActions.loadSellPricesForPromotionRes({ ...result.data, product_groups }));
        }
    } catch (e) {
        yield put(PromotionActions.loadSellPricesForPromotionErr());
        console.log(e);
    }
}

export function* loadSellPricesForPromotionWatcher() {
    yield takeLatest(LOAD_SELL_PRICES_FOR_PROMOTION, loadSellPricesForPromotionSaga);
}
// L O A D   S E L L   P R I C E S   F O R   P R O M O T I O N

// E D I T   P R O M O T I O N
function* editPromotionSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield editPromotionApi(action.data);

        if (result.status === 202) {
            yield call(updatePromotionTranslate, action);
            yield call(attachResellersProductGroupToPromotion, action);

            yield put(PromotionActions.editPromotionRes());
            yield delay(1000);

            if (action.isCustomized) {
                yield call(loadEditablePromotionSaga, {
                    ...action,
                    data: {
                        ...action.data,
                        id: action.data.promotion_id,
                    },
                });
                yield put(PromotionActions.savePromoToCustomizeRes({
                    ...action.data,
                    resellers: action.resellersProductGroup.resellers,
                }));
                yield delay(50);
                yield put(push(`/marketing/promotions/customize/${action.data.promotion_id}`));
            } else {
                yield put(push('/marketing/promotions/'));
            }

            setNotification('success', locale, 'global.success', 'promotion.notification.editPromotionSuccess');
        } else {
            yield put(PromotionActions.editPromotionErr());
            setNotification('error', locale, 'global.error', 'promotion.notification.editPromotionError');
        }
    } catch (e) {
        yield put(PromotionActions.editPromotionErr());
        setNotification('error', locale, 'global.error', 'promotion.notification.editPromotionError');
        console.log(e);
    }
}

export function* editPromotionWatcher() {
    yield takeLatest(EDIT_PROMOTION, editPromotionSaga);
}
// E D I T   P R O M O T I O N

// L O A D   S E L L P R I C E S
function* loadPromotionSellPrices(action) {
    const { promoSellPrices } = yield select(getPromotion);
    const { offset, limit } = promoSellPrices;

    try {
        const params = { limit, offset };

        const sendFilters = {};
        sendFilters._id = action.promotion_id;

        if (promoSellPrices.filters.productGroup?.length > 0) {
            sendFilters.product_group_id = promoSellPrices.filters.productGroup;
        }

        if (promoSellPrices.filters.resellers?.length > 0) {
            sendFilters.reseller_id = promoSellPrices.filters.resellers;
        }

        params.filter = JSON.stringify(sendFilters);
        params.sort_by = JSON.stringify({ sell_price_id: -1 });

        const result = yield getSellPrices(params);

        if (result.status === 200) {
            const { hits } = result.data;
            let product_groups = [];
            let sell_prices_ids = [];

            if (hits) {
                hits.forEach((hit) => {
                    product_groups = [
                        ...product_groups,
                        hit.promotion.product_group_id,
                    ];
                    sell_prices_ids = [
                        ...sell_prices_ids,
                        hit.promotion.sell_price_id,
                    ];
                });

                product_groups = uniq(product_groups);

                const getProductGroups = yield getProductGroupsApi({ filter: JSON.stringify({ id: product_groups }) });
                product_groups = getProductGroups.data.hits.map(hit => ({
                    id: hit.id,
                    name: hit.name,
                    unique_name: hit.unique_name,
                }));

                yield put(PromotionActions.loadPromotionSellPricesRes({ ...result.data, product_groups, sell_prices_ids }));
            }
        }
    } catch (e) {
        yield put(PromotionActions.loadPromotionSellPricesErr());
        console.log(e);
    }
}

export function* loadPromotionSellPricesWatcher() {
    yield takeLatest(LOAD_PROMOTION_SELLPRICES, loadPromotionSellPrices);
}
// L O A D   S E L L P R I C E S

// A T T A C H   S E L L P R I C E S   T O   P R O M O T I O N
function* attachSellPricesToPromotion(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {
            sell_prices: [{
                sell_price_id: action.data.sell_price_id,
                product_group_id: action.data.product_group_id,
                reseller_id: action.data.reseller_id,
                sell_price: parseFloat(action.data.sellprice),
                between_sell_price: parseFloat(action.data.betweenprice),
            }],
        };
        params.promotion_id = action.data.promotion_id;

        const paramsSellPrice = {
            filter: JSON.stringify({
                _id: action.data.promotion_id,
                sell_price_id: action.data.sell_price_id,
            }),
        };

        const resultSellPrices = yield getSellPrices(paramsSellPrice);

        if (resultSellPrices.status === 200) {
            if (resultSellPrices.data.hits.length > 0) {
                setNotification('error', locale, 'global.error', 'promotion.notification.sellPriceAlreadyExist');
                yield put(PromotionActions.attachSellpricesToPromotionErr());
            } else {
                const result = yield attachResellersProductGroupToPromotionApi(params);

                if (result.status === 202) {
                    yield put(PromotionActions.attachSellpricesToPromotionRes());
                    yield call(loadPromotionSellPrices, action.data);
                    setNotification('success', locale, 'global.success', 'promotion.notification.addSellPriceSuccess');
                }
            }
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'promotion.notification.addSellPriceError');
        yield put(PromotionActions.attachSellpricesToPromotionErr());
        console.log(e);
    }
}

export function* attachSellPricesToPromotionWatcher() {
    yield takeLatest(ATTACH_SELLPRICES_TO_PROMOTION, attachSellPricesToPromotion);
}
// A T T A C H   S E L L P R I C E S   T O   P R O M O T I O N

// U P D A T E   S E L L   P R I C E S
function* updateSellPricesSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield updateSellPricesApi(action.data[0]);

        if (result.status === 202) {
            if (action.data[0].sell_prices.length > 1) {
                setNotification('success', locale, 'global.success', 'promotion.notification.editSellingPricesSuccess');
            } else {
                setNotification('success', locale, 'global.success', 'promotion.notification.editSellPriceSuccess');
            }

            const sellPricesIds = action.data[0].sell_prices.map(s => s.sell_price_id);
            yield put(PromotionActions.updateSellPricesRes(sellPricesIds));
        }
    } catch (e) {
        if (action.data[0].sell_prices.length > 1) {
            setNotification('error', locale, 'global.error', 'promotion.notification.editSellingPricesError');
        } else {
            setNotification('error', locale, 'global.error', 'promotion.notification.editSellPriceError');
        }
        yield put(PromotionActions.updateSellPricesErr());
        console.log(e);
    }
}

export function* updateSellPricesWatcher() {
    yield takeEvery(UPDATE_SELL_PRICES, updateSellPricesSaga);
}
// U P D A T E   S E L L   P R I C E S

// D E L E T E   S E L L   P R I C E S
function* deleteSellPricesSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield deleteSellPricesApi(action.data[0]);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'promotion.notification.deleteSellPriceSuccess');

            const sellPricesIds = action.data[0].sell_price_id;

            yield put(PromotionActions.deleteSellPricesRes(sellPricesIds));
            yield put({ type: LOAD_PROMOTION_SELLPRICES, promotion_id: action.data[0].promotion_id });
            yield call(loadPromotionSellPrices, action.data[0]);
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'promotion.notification.deleteSellPriceError');
        yield put(PromotionActions.deleteSellPricesErr());
        console.log(e);
    }
}

export function* deleteSellPricesWatcher() {
    yield takeEvery(DELETE_SELL_PRICES, deleteSellPricesSaga);
}
// D E L E T E   S E L L   P R I C E S

// S E T   D I S A B L E   P R O M O T I O N
function* setDisablePromotionSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {
            promotion_id: action.key,
            status: action.value,
        };

        const result = yield enableDisablePromotionApi(params);
        if (result.status === 202) {
            yield put(PromotionActions.setDisablePromotionRes(result.data));
        } else {
            setNotification('error', locale, 'global.error', 'promotion.notification.disablePromotionError');
            yield put(PromotionActions.loadPromotionsErr());
        }
        yield put({ type: LOAD_PROMOTIONS });
    } catch (e) {
        yield put(PromotionActions.loadPromotionsErr());
        console.log(e);
    }
}

export function* setDisablePromotionWatcher() {
    yield takeLatest(SET_DISABLE_PROMOTION, setDisablePromotionSaga);
}
// S E T   D I S A B L E  BP R O M O T I O N
